<template>
  <div>
    <b-modal
      id="bv-modal-create"
      class="z-index"
      title="Добавить новую дистанцию"
      ok-only
      ok-title="Добавить"
      @ok="addNewSport"
      @hidden="resetModal"
    >
      <!--  Название дистанции   -->
      <div class="distance_name distance_wrapper">
        <label
          for="distanceName"
          class="distance_label"
          >Имя дистанции</label
        >
        <b-form-input
          id="distanceName"
          v-model="distance.name"
          placeholder="Имя дистанции"
          label="Имя дистанции"
          vs-placeholder="Имя дистанции"
        />
      </div>
      <div class="distance_wrapper distance_double__wrapper">
        <b-form-checkbox
          id="checkDouble"
          v-model="distance.is_multi_registration"
          checked="false"
          class="custom-control-primary"
          name="check-view"
          switch
        />
        <label
          class="distance_double__label"
          for="checkDouble"
          >Отключить проверку дублей?</label
        >
      </div>
      <div class="distance_wrapper distance_double__wrapper">
        <b-form-checkbox
          id="checkPatronymicRequired"
          v-model="distance.is_patronymic_required"
          checked="false"
          class="custom-control-primary"
          name="check-patronymic-required"
          switch
        />
        <label
          class="distance_double__label"
          for="checkPatronymicRequired"
          >Отчество обязательно?</label
        >
      </div>

      <!--   Формат дистанции   -->
      <div class="distance_wrapper distance_format">
        <div class="">
          <div
            v-b-toggle.participationFormat
            class="distance_form__button"
            @click="toggleCollapsed('participationFormat')"
          >
            <span>Формат участия</span>
            <span>{{ collapsedStates.participationFormat ? '🔼' : '🔽' }}</span>
          </div>
          <b-collapse id="participationFormat">
            <div
              v-for="(format, index) in sport_formats"
              :key="'format' + index"
            >
              <b-form-radio
                v-model="distance.format"
                name="sport_format"
                class="distance_format__input"
                :value="format"
                @input="selectFormat"
              >
                {{ format }}
              </b-form-radio>
            </div>
          </b-collapse>
        </div>
        <template v-if="distance.format === 'Лично'">
          <div>
            <div class="distance_form">
              <distance-block
                :distance="distance"
                :mode="'Лично'"
              />
            </div>
            <div class="mt-3 mb-3 mt-3">
              Группы ({{ distance.groups.length }})
            </div>
            <template v-for="(group, index) in distance.groups">
              <group
                :key="'group' + index"
                :groups="distance.groups"
                :group="group"
                :group-index="index"
                @update-group="updateGroup"
                @delete-group="deleteGroup"
              />
            </template>
            <div
              id="add-group-button-tooltip"
              class="inline-block mt-2 group-buttons"
              tabindex="0"
            >
              <group-templates @select="addGroupsFromTemplate" />
              <b-button
                size="small"
                @click="addGroup"
              >
                Добавить группу
              </b-button>
            </div>
          </div>
        </template>
        <template v-if="distance.format === 'Эстафета'">
          <distance-block :distance="distance" />
          <div class="distance_form">
            <div
              v-b-toggle.stages
              class="distance_form__button"
              @click="toggleCollapsed('stages')"
            >
              <div>Этапы</div>
              <span>{{ collapsedStates.stages ? '🔼' : '🔽' }}</span>
            </div>
            <b-collapse id="stages">
              <stage-block
                :stages="distance.stages"
                :restircted-stages="[]"
                @deleteStage="deleteStage"
              />
              <b-button
                class="mt-2"
                size="small"
                @click="addStage"
              >
                Добавить этап
              </b-button>
            </b-collapse>
          </div>
          <div class="mt-3 mb-3 mt-3">
            Группы ({{ distance.groups.length }})
          </div>
          <template v-for="(group, index) in distance.groups">
            <group
              :key="'group' + index"
              :groups="distance.groups"
              :group="group"
              :group-index="index"
              :distance-format="distance.format"
              :stages="distance.stages"
              @update-group="updateGroup"
              @delete-group="deleteGroup"
            />
          </template>
          <div
            id="add-group-button-tooltip"
            class="inline-block mt-2 group-buttons"
            tabindex="0"
          >
            <group-templates @select="addGroupsFromTemplate" />
            <b-button
              size="small"
              @click="addGroup"
            >
              Добавить группу
            </b-button>
          </div>
        </template>
      </div>
      <template>
        <div class="distance_wrapper">
          <div>
            <div
              v-b-toggle.addFieldsSeparate
              class="distance_form__button"
              @click="toggleCollapsed('addFieldsSeparate')"
            >
              Дополнительные поля - {{ distance.additional_fields.length }}
              <span>{{ collapsedStates.addFieldsSeparate ? '🔼' : '🔽' }}</span>
            </div>
          </div>
          <b-collapse id="addFieldsSeparate">
            <template
              v-for="(additionalField, index) in distance.additional_fields"
            >
              <additionalField
                :key="'additionalField' + index"
                :distance="distance"
                :field="additionalField"
                :field-index="index"
                @update-field="updateField"
                @delete-field="deleteField"
              />
            </template>
            <b-button
              class="mt-1"
              size="small"
              @click="addField"
            >
              Добавить доп поле
            </b-button>
          </b-collapse>
        </div>
      </template>

      <div class="distance_wrapper">
        <div
          v-b-toggle.discounts
          class="distance_form__button"
          @click="toggleCollapsed('discounts')"
        >
          <div>Скидки по возрасту</div>
          <span>{{ collapsedStates.discounts ? '🔼' : '🔽' }}</span>
        </div>
        <b-collapse id="discounts">
          <div>
            <div class="discount__items">
              <div
                v-for="(item, i) in distance.discounts"
                :key="'discount_' + i"
                class="discount__item"
              >
                <div
                  class="discount__item-del discount__item-del"
                  @click="distance.discounts.splice(i, 1)"
                >
                  <svg
                    width="10"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 320 512"
                    class="delete-icon"
                  >
                    <path
                      d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                    />
                  </svg>
                </div>
                <label
                  for="priceFrom"
                  class="distance_label"
                  >Возраст от</label
                >
                <b-form-input
                  id="priceFrom"
                  v-model.number="item.c_from"
                  type="number"
                  no-wheel
                  placeholder="Возраст от"
                  class="distance_input__description"
                />
                <label
                  for="priceTo"
                  class="distance_label"
                  >Возраст до</label
                >
                <b-form-input
                  id="priceTo"
                  v-model.number="item.c_to"
                  type="number"
                  no-wheel
                  placeholder="Возраст до"
                  class="distance_input__description"
                />
                <discount-switcher
                  :discount-is-percent="item.percent"
                  :value="+item.value"
                  @discountType="value => (item.percent = value)"
                  @input="value => (item.value = value)"
                />
              </div>
            </div>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="primary"
              class="mt-1"
              @click="
                distance.discounts.push({
                  c_to: null,
                  c_from: null,
                  value: null,
                  percent: false,
                })
              "
            >
              Добавить скидку
            </b-button>
          </div>
        </b-collapse>
      </div>

      <div class="distance_wrapper">
        <div
          v-b-toggle.detailed_description
          class="distance_form__button"
          @click="toggleCollapsed('detailed_description')"
        >
          <div>Полное описание дистанции</div>
          <span>{{ collapsedStates.detailed_description ? '🔼' : '🔽' }}</span>
        </div>
        <b-collapse id="detailed_description">
          <admin-quill-editor
            ref="detailed_description_editor"
            v-model="distance.detailed_description"
            :options="quillEditorOptions"
            @change="onEditorChange($event)"
          />
        </b-collapse>
      </div>

      <div class="distance_wrapper">
        <div
          v-b-toggle.scheme
          class="distance_form__button"
          @click="toggleCollapsed('scheme')"
        >
          <div>Схема проезда дистанции</div>
          <span>{{ collapsedStates.scheme ? '🔼' : '🔽' }}</span>
        </div>
        <b-collapse id="scheme">
          <div class="">
            <div class="">
              <!-- Загрузка изображения схемы -->
              <b-form-group label="Загрузка изображения схемы">
                <file-uploader
                  :key="'distanceSchemeFile_' + (distance.scheme_image_id || 'new')"
                  :default="distance.scheme_image"
                  :value="distance.scheme_image_id"
                  @input="val => {
                    distance.scheme_image_id = val
                    if (!val) {
                      distance.scheme_image = null
                    }
                  }"
                  @updatePhotos="file => (distance.scheme_image = file)"
                />
              </b-form-group>

              <!-- iframe карты -->
              <b-form-group
                label="Вставьте iframe карты (например, Google или Яндекс)"
              >
                <a
                  href="https://yandex.ru/map-constructor/"
                  target="_blank"
                >
                  Конструктор схемы
                </a>

                <b-form-textarea
                  v-model="distance.scheme_frame"
                  placeholder="<iframe ...></iframe>"
                  rows="4"
                />

                <b-button
                  variant="primary"
                  class="mt-1"
                  @click="showIframePreview = !showIframePreview"
                >
                  {{ showIframePreview ? 'Скрыть' : 'Предпросмотр' }}
                </b-button>

                <div
                  v-if="showIframePreview"
                  class="iframe-preview mt-2"
                >
                  <div v-html="distance.scheme_frame"></div>
                </div>
              </b-form-group>
            </div>
          </div>
        </b-collapse>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BButton,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BFormRadio,
  BModal,
  BCollapse,
  VBPopover,
  VBToggle,
  BCardHeader,
  BFormTextarea,
} from 'bootstrap-vue'
import { v4 as uuidv4 } from 'uuid'
import Ripple from 'vue-ripple-directive'
import GroupTemplates from '@/views/starts/GroupTemplates'
import DistanceBlock from './DistanceBlock.vue'
import Group from './Group.vue'
import StageBlock from './StageBlock.vue'
import AdditionalField from './AdditionalField.vue'
import DiscountSwitcher from '@/global-components/DiscountSwitcher.vue'
import FileUploader from '@/global-components/FileUploader.vue'
import { buildQuillOptions } from '@/plugins/quill-config'

export default {
  name: 'DistanceModalCreate',
  components: {
    BCardHeader,
    StageBlock,
    Group,
    DistanceBlock,
    GroupTemplates,
    BFormInput,
    BButton,
    BModal,
    BFormRadio,
    BFormGroup,
    BFormCheckbox,
    AdditionalField,
    DiscountSwitcher,
    BCollapse,
    BFormTextarea,
    FileUploader,
  },
  directives: {
    'b-popover': VBPopover,
    'b-toggle': VBToggle,
    Ripple,
  },
  props: ['age_groups', 'select_kinds_sport', 'start'],
  computed: {
    quillEditorOptions() {
      return buildQuillOptions({
        startId: this.start?.id,
        requireStartPick: false,
        includeStartInShortcode: false,
      })
    },
  },
  data() {
    return {
      activeFormat: '',
      distance: {
        description: '',
        format: '',
        slots: 1,
        track_link: {},
        track_link_id: null,
        track_code: '',
        event_date: null,
        length_m: null,
        is_patronymic_required: false,
        groups: [],
        discounts: [],
        additional_fields: [],
        stages: [],
        detailed_description: '',
        scheme_frame: '',
        scheme_image_id: null,
        scheme_image: null,
      },
      schemeRouteFile: null,
      showIframePreview: false,
      groups: [],
      distanceStages: [],
      slotDisable: false,
      activeSelectSport: false,
      new_kind_sport: '',
      sport_formats: ['Лично', 'Эстафета'],
      templateGroups: [],
      collapsedStates: {
        participationFormat: false,
        stages: false,
        addFieldsSeparate: false,
        discounts: false,
        detailed_description: false,
        scheme: false,
      },
    }
  },
  watch: {
    'distance.format': {
      handler(newValue) {
        if (newValue === 'Лично') {
          this.distance.groups = this.distance.groups.filter(
            group => group.format !== 'Minimum' && group.format !== 'Combined',
          )
        } else if (newValue === 'Эстафета') {
          if (this.templateGroups.length) {
            const nedeedGroups = this.templateGroups.filter(
              group =>
                group.format === 'Minimum' || group.format === 'Combined',
            )
            this.distance.groups = this.distance.groups.concat(nedeedGroups)
          }
        }
      },
    },
  },
  methods: {
    deleteStage(stageToDelete) {
      const index = this.distance.stages.findIndex(
        stage => stage === stageToDelete,
      )
      if (index !== -1) {
        this.distance.stages.splice(index, 1)
      }
    },
    onEditorChange(event) {
      event.quill
    },
    addStage() {
      this.distance.stages.push({
        uuid: uuidv4(),
        name: null,
        sex: null,
        additional_fields: [],
        kind_of_sport_id: null,
        stage_length: null,
      })
    },
    addGroupsFromTemplate(groups) {
      if (this.templateGroups.length !== 0) {
        const { template_id } = this.templateGroups[0]
        this.distance.groups = this.distance.groups.filter(
          group => group.template_id !== template_id,
        )
      }
      this.templateGroups = groups
      if (this.distance.format === 'Лично') {
        const filteredGroups = groups.filter(
          group =>
            group.format === 'Male' ||
            group.format === 'Female' ||
            group.format === 'Any',
        )
        this.distance.groups = this.distance.groups.concat(filteredGroups)
      } else if (this.distance.format === 'Эстафета') {
        this.distance.groups = this.distance.groups.concat(groups)
      }
    },
    addGroup() {
      if (this.distance.format === 'Лично') {
        this.distance.groups.push({
          name: null,
          age_from: null,
          age_to: null,
          age_reference_date: null,
        })
      } else if (this.distance.format === 'Эстафета') {
        this.distance.groups.push({
          name: null,
          age_from: null,
          age_to: null,
          age_reference_date: null,
          combination_dict: {},
        })
      }
    },
    addNewSport() {
      if (this.distance.name) {
        this.distance.uuid = uuidv4()
        if (
          this.distance.groups.length > 0 &&
          this.distance.format === 'Эстафета'
        ) {
          this.transformGroupsFields()
        }
        if (this.distance.format === 'Эстафета' || this.distance.groups) {
          this.distance.groups.forEach(group => {
            if (group.combination_list) {
              group.combination_list.forEach(stage => {
                if (!stage.sex) {
                  stage.sex = 'Any'
                }
              })
            }
          })
        }
        this.distance.groups = this.distance.groups.map(obj => {
          if (obj.template_id) {
            const { id, ...rest } = obj
            return rest
          }
          return obj
        })
        console.log(this.distance.groups)
        this.select_kinds_sport.push(this.distance)
      }
      this.groups = []
      this.new_kind_sport = ''
      this.activeFormat = ''
      this.distanceStages = []
      this.distance = {
        description: '',
        slots: 1,
        format: '',
        track_link: {},
        track_link_id: null,
        track_code: '',
        event_date: null,
        length_m: null,
        is_patronymic_required: false,
        groups: [],
        additional_fields: [],
        discounts: [],
        scheme_frame: '',
        scheme_image_id: null,
        scheme_image: null,
      }
    },
    transformGroupsFields() {
      this.distance.groups.forEach(group => {
        if (group.combination_dict) {
          if (Object.keys(group.combination_dict).length > 0) {
            group.combination_list = []
            for (const combinationDictKey in group.combination_dict) {
              group.combination_list.push({
                stageUUID: combinationDictKey,
                sex:
                  group.combination_dict[combinationDictKey].length > 1 ||
                  !group.combination_dict[combinationDictKey]
                    ? 'Any'
                    : group.combination_dict[combinationDictKey][0],
              })
            }
          }
        }
        delete group.combination_dict
      })
    },
    updateGroup(group, groupIndex) {
      this.groups[groupIndex] = group
    },
    deleteGroup(group, indexGroup) {
      if (this.templateGroups.length && group.template_id) {
        const indexDeletedGroup = this.templateGroups.findIndex(
          item =>
            item.template_id === group.template_id && item.id === group.id,
        )
        this.templateGroups.splice(indexDeletedGroup, 1)
      }
      this.distance.groups.splice(indexGroup, 1)
    },
    resetModal() {
      this.schemeRouteIframe = ''
      this.schemeRouteFileId = null
      this.schemeRouteFile = null
      this.showIframePreview = false
      this.groups = []
      this.new_kind_sport = ''
      this.activeFormat = ''
      this.distanceStages = []
      this.distance = {
        description: '',
        slots: 1,
        track_link: {},
        track_link_id: null,
        track_code: '',
        event_date: null,
        length_m: null,
        is_patronymic_required: false,
        groups: [],
        additional_fields: [],
        stages: [],
        format: '',
        discounts: [],
        scheme_frame: '',
        scheme_image_id: null,
        scheme_image: null,
      }
      this.templateGroups = []
      this.collapsedStates = {
        participationFormat: false,
        stages: false,
        addFieldsSeparate: false,
        discounts: false,
      }
    },
    addField() {
      const distance_uuid = uuidv4()
      this.distance.additional_fields.push({
        name: '',
        type: '',
        uuid: distance_uuid,
      })
    },
    updateField(field, fieldIndex) {
      this.distance.additional_fields[fieldIndex] = field
    },
    deleteField(fieldIndex) {
      this.distance.additional_fields.splice(fieldIndex, 1)
    },
    toggleCollapsed(collapseId) {
      this.collapsedStates[collapseId] = !this.collapsedStates[collapseId]
    },
    selectFormat(format) {
      this.distance.stages = []
      if (format === 'Лично') {
        this.distance.stages.push({
          uuid: uuidv4(),
          name: 'Лично',
          sex: '',
          additional_fields: [],
          kind_of_sport_id: null,
          stage_length: '',
        })
      } else {
        this.distance.stages.push({
          uuid: uuidv4(),
          name: '',
          sex: '',
          additional_fields: [],
          kind_of_sport_id: null,
          stage_length: '',
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.group-buttons {
  display: flex;
}

.add-fille {
  margin: 10px 0;
}

.distance {
  margin-top: 30px;
}

.input__code {
  margin-top: 15px !important;
}

.distances__minus {
  margin-left: 5px;
  transition: 0.3s;

  &:hover {
    cursor: pointer;
    transform: scale(1.1);
  }
}

.sport-block {
  border-bottom: 1px solid #e5e5e5;
}

.z-index {
  z-index: 52011;
}

.price {
  &__title {
    margin-top: 20px;
  }

  &__items {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -15px 20px -15px;
  }

  &__item {
    padding: 20px;
    border: 1px solid #00000012;
    border-radius: 20px;
    position: relative;
    width: calc(50% - 30px);
    margin: 10px 15px 0 15px;

    &-del {
      position: absolute;
      right: 20px;
      top: 10px;
    }
  }
}

.distance_double__label {
  font-size: 14px;
  margin-bottom: 0;
}

.distance_double__wrapper {
  display: flex;
  align-items: center;
  column-gap: 1rem;
}

.iframe-preview {
  overflow: hidden;
}

.distance_wrapper {
  background-color: #f8f8f8;
  border-radius: 10px;

  padding: 10px;

  margin-bottom: 1rem;

  &:last-child {
    margin-bottom: 0;
  }
}

.distance_form {
  margin-bottom: 1rem;
}

.test {
  margin-bottom: 0;
}

.distance_name {
  &__input {
    margin-top: 0.5rem;
  }
}

.distance_format {
  &__input {
    margin-top: 0.5rem;
  }
}

.discount__item-del {
  display: flex;
  align-items: center;
  justify-content: end;
}

.distance_label {
  display: block;
  font-size: 0.75rem;
}

.distance_title {
  display: block;
  margin-bottom: 0.5rem;
}

.distance_form__button {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.delete-icon {
  cursor: pointer;
  fill: #5e5873;
  transition: fill 0.2s ease; /* Плавное изменение цвета */
}

.delete-icon:hover {
  fill: #dc3545; /* Красный цвет при наведении */
}

.distance_input__description {
  margin-bottom: 0.5rem;
}
</style>
<style>
.flex {
  display: flex;
}

.justify-end {
  justify-content: end;
}

.inline-block {
  display: inline-block;
}

.age {
  display: flex;
}

.age input:last-child {
  margin-left: 30px;
}

.price__item .form-control {
  margin-top: 20px;
}
</style>
